import axios from 'axios';
import { API_BASE_URL, API_ENDPOINTS } from '../constants';

const API_URL = API_BASE_URL;

export const fetchPortfolioPercentage = async () => {
  try {
    const response = await axios.get(`${API_URL}${API_ENDPOINTS.PORTFOLIO_PERCENTAGE}`);
    return {
      portfolioPercentage: response.data.portfolio_percentage,
      ndaqPercentage: response.data.ndaq_percentage,
      spyPercentage: response.data.spy_percentage,
      arkkPercentage: response.data.arkk_percentage,
    };
  } catch (error) {
    console.error('Error fetching portfolio percentage:', error);
    return {
      portfolioPercentage: null,
      ndaqPercentage: null,
      spyPercentage: null,
      arkkPercentage: null,
    };
  }
};

export const fetchHoldings = async () => {
  try {
    const response = await axios.get(`${API_URL}${API_ENDPOINTS.HOLDINGS}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching holdings:', error);
    return [];
  }
};

export const fetchRankings = async () => {
  try {
    const response = await axios.get(`${API_URL}${API_ENDPOINTS.RANKINGS}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching rankings:', error);
    return [];
  }
};

export const fetchRecentTrades = async () => {
  try {
    const response = await axios.get(`${API_URL}${API_ENDPOINTS.RECENT_TRADES}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching recent trades:', error);
    return [];
  }
};

export const fetchTickerData = async (tickerSymbol) => {
  try {
      const response = await fetch(`${API_URL}${API_ENDPOINTS.TICKER}/${tickerSymbol}`);
    const data = await response.json();

    if (response.ok) {
      // Calculate total weight for percentages
      const totalWeight = data.buy_weight + data.sell_weight + data.hold_weight;
      const buyPercentage = ((data.buy_weight / totalWeight) * 100).toFixed(1);
      const sellPercentage = ((data.sell_weight / totalWeight) * 100).toFixed(1);
      const holdPercentage = ((data.hold_weight / totalWeight) * 100).toFixed(1);

      return {
        success: true,
        data: {
          ticker: data.ticker,
          price: parseFloat(data.current_price),
          decision: data.decision,
          buy: parseFloat(buyPercentage),
          sell: parseFloat(sellPercentage),
          hold: parseFloat(holdPercentage),
          buy_weight: data.buy_weight,
          sell_weight: data.sell_weight,
          hold_weight: data.hold_weight,
        },
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: data.error || 'Invalid ticker symbol. Please try again with a valid stock ticker.',
      };
    }
  } catch (error) {
    console.error('Error fetching ticker data:', error);
    return {
      success: false,
      data: null,
      error: 'An error occurred while connecting to the server. Please try again later.',
    };
  }
};

const apiService = {
  fetchPortfolioPercentage,
  fetchHoldings,
  fetchRankings,
  fetchRecentTrades,
  fetchTickerData,
};

export default apiService;
